import React from 'react';
import { Link } from 'react-router-dom';

const Hero = ({ title, description, buttons }) => {
    return (
        <section className="container mx-auto px-4 pb-20 pt-0 text-center">
            <div className="glass-panel p-12 mx-auto relative overflow-hidden animate-fade-in opacity-0">
                <div className="relative z-10">
                    <h1
                        className="text-3xl md:text-5xl font-bold mb-6 pb-1 bg-clip-text text-transparent bg-gradient-to-r from-primary-blue to-[#00C6FF] animate-slide-up opacity-0 animation-delay-100"
                        style={{
                            background: 'var(--accent-gradient)',
                            WebkitBackgroundClip: 'text',
                            WebkitTextFillColor: 'transparent'
                        }}
                    >
                        {title.split('\n').map((line, index) => (
                            <span key={index}>
                                {line}
                                {index < title.split('\n').length - 1 && <br />}
                            </span>
                        ))}
                    </h1>
                    <p className="text-xl md:text-2xl text-text-light mb-8 max-w-4xl mx-auto animate-slide-up opacity-0 animation-delay-200">
                        {description}
                    </p>
                    <div className="flex flex-col md:flex-row justify-center gap-4 animate-slide-up opacity-0 animation-delay-300">
                        {buttons.map((button) => (
                            <Link key={button.id} to={button.link}>
                                <button
                                    className={
                                        button.primary
                                            ? "glass-button text-lg px-8 py-4 w-full md:w-auto"
                                            : "glass-panel px-8 py-4 text-primary-blue font-bold hover:bg-white/50 transition-colors w-full md:w-auto !rounded-2xl"
                                    }
                                >
                                    {button.text}
                                </button>
                            </Link>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Hero;
